// No dot in the class: "example.com:8080" is a host and port, not a scheme, while
// every scheme Quill whitelists (http, https, mailto, tel, sms) is dotless.
const HAS_SCHEME = /^[a-z][a-z0-9+-]*:/i
const IS_SITE_RELATIVE = /^[#/]/
// A path can legally hold an "@" ("youtube.com/@channel"), and RFC 5322 lets an email
// local part hold a "/", so the slash is what separates the two cases.
const IS_EMAIL = /^[^\s/@]+@[^\s/@]+$/

// Quill keeps a link's href exactly as typed, so "www.example.com" is stored as a
// relative path and the browser resolves it against whatever page renders it. Give
// scheme-less hosts an https:// prefix so they stay absolute in the app and in email.
// Keep the rules here in sync with ContentSanitizer.absolutize_href.
export function absolutizeLinkUrl(url: string): string {
  const trimmed = url.trim()

  if (trimmed.startsWith("//")) return `https:${trimmed}`
  if (trimmed === "" || HAS_SCHEME.test(trimmed) || IS_SITE_RELATIVE.test(trimmed)) return trimmed
  if (IS_EMAIL.test(trimmed)) return `mailto:${trimmed}`

  return `https://${trimmed}`
}
